import { c as config } from './chunk-bd4264c6.js';
import { _ as __vue_normalize__, r as registerComponent, u as use } from './chunk-cca88db8.js'; //

var script = {
  name: 'BProgress',
  props: {
    type: {
      type: [String, Object],
      "default": 'is-darkgrey'
    },
    size: String,
    value: {
      type: Number,
      "default": undefined
    },
    max: {
      type: Number,
      "default": 100
    },
    showValue: {
      type: Boolean,
      "default": false
    },
    format: {
      type: String,
      "default": 'raw',
      validator: function validator(value) {
        return ['raw', 'percent'].indexOf(value) >= 0;
      }
    },
    precision: {
      type: Number,
      "default": 2
    },
    keepTrailingZeroes: {
      type: Boolean,
      "default": false
    },
    locale: {
      type: [String, Array],
      "default": function _default() {
        return config.defaultLocale;
      }
    }
  },
  computed: {
    isIndeterminate: function isIndeterminate() {
      return this.value === undefined || this.value === null;
    },
    newType: function newType() {
      return [this.size, this.type, {
        'is-more-than-half': this.value && this.value > this.max / 2
      }];
    },
    newValue: function newValue() {
      if (this.value === undefined || this.value === null || isNaN(this.value)) {
        return undefined;
      }

      var minimumFractionDigits = this.keepTrailingZeroes ? this.precision : 0;
      var maximumFractionDigits = this.precision;

      if (this.format === 'percent') {
        return new Intl.NumberFormat(this.locale, {
          style: 'percent',
          minimumFractionDigits: minimumFractionDigits,
          maximumFractionDigits: maximumFractionDigits
        }).format(this.value / this.max);
      }

      return new Intl.NumberFormat(this.locale, {
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits
      }).format(this.value);
    }
  },
  watch: {
    /**
     * When value is changed back to undefined, value of native progress get reset to 0.
     * Need to add and remove the value attribute to have the indeterminate or not.
     */
    isIndeterminate: function isIndeterminate(indeterminate) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.progress) {
          if (indeterminate) {
            _this.$refs.progress.removeAttribute('value');
          } else {
            _this.$refs.progress.setAttribute('value', _this.value);
          }
        }
      });
    }
  }
};
/* script */

var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "progress-wrapper"
  }, [_c('progress', {
    ref: "progress",
    staticClass: "progress",
    "class": _vm.newType,
    attrs: {
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    }
  }, [_vm._v(_vm._s(_vm.newValue))]), _vm.showValue ? _c('p', {
    staticClass: "progress-value"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.newValue))])], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

var Progress = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Progress);
  }
};
use(Plugin);
export default Plugin;
export { Progress as BProgress };